import { API_BASE } from './api';

/**
 * Mirrors the server-side rule in routes/api/admin/group.js:182-193.
 * Roles outside this set get "User doesn't have permission to access groups."
 */
export function canAccessGroups(role) {
  const r = Number(role);
  return r > 3 || r === 2 || r === 3;
}

/** Map one getUserInfoForApp vehicleInfo entry to the app's device shape. */
export function mapVehicleInfoToDevice(v) {
  const p = v?.VehicleProfile || {};
  return {
    deviceId: v?.deviceId,
    vehicleId: p.VehicleName || v?.deviceId,
    _id: v?._id,
    carProfile: {
      model: p.Model || null,
      make: p.Make,
      regNo: p.RegNo,
      makeYear: p.Year,
    },
  };
}

/**
 * Devices assigned directly to the authenticated user, with carProfile.
 *
 * role 0 short-circuits server-side and also merges tagged vehicles, so the
 * flag is omitted. For every other role userData=true is REQUIRED: without it
 * the server walks every group member serially (one group has 746 users).
 * Never throws — returns [] so callers can fall back.
 */
export async function fetchOwnDevices(token, role) {
  if (!token) return [];
  const flag = Number(role) === 0 ? '' : '&userData=true';
  try {
    const res = await fetch(
      `${API_BASE}/api/admin/getUserInfoForApp?api_access_token=${token}${flag}`
    );
    if (!res.ok) return [];
    const json = await res.json();
    if (json?.status !== 'success') return [];
    return (json.userInfo?.vehicleInfo || [])
      .map(mapVehicleInfoToDevice)
      .filter((d) => d.deviceId);
  } catch (e) {
    console.error('fetchOwnDevices failed:', e);
    return [];
  }
}
